import { Controller } from "@hotwired/stimulus";
import { Loader } from "@googlemaps/js-api-loader";

export default class extends Controller {
  static targets = ["map"];

  declare mapTarget: HTMLElement;
  declare hasMapTarget: boolean;

  map?: google.maps.Map;
  infoWindow?: google.maps.InfoWindow;

  connect(): void {
    const mapsKey = this.data.get("maps-key");
    if (!this.hasMapTarget || !mapsKey) return;
    void this.loadMaps(mapsKey).then(() => this.createMap());
  }

  disconnect() {
    this.infoWindow = undefined;
    this.map = undefined;
  }

  private async loadMaps(mapsApiKey: string): Promise<void> {
    const loader = new Loader({ apiKey: mapsApiKey, region: "NZ", language: "en" });
    await loader.load();
  }

  private createMap(): void {
    const boundaryData = this.data.get("boundary") ?? "";
    
    if (boundaryData == "") return;
    
    const parsedBoundaryData = JSON.parse(boundaryData) as object;

    this.map = new google.maps.Map(this.mapTarget, {
      center: { lat: 0, lng: 0 },
      zoom: 14,
    });
    
    const boundaryLocations = this.map.data.addGeoJson(parsedBoundaryData);
    const bounds = new google.maps.LatLngBounds();

    boundaryLocations.forEach((feature) => {
      feature.getGeometry()?.forEachLatLng((latlng) => {
        bounds.extend(latlng);
      });
    });

    this.map.fitBounds(bounds);

    this.infoWindow = new google.maps.InfoWindow();

    this.map.data.addListener("click", (event: google.maps.Data.MouseEvent) => {
      if (!event.latLng || !this.infoWindow) return;
        const location = event.feature.getProperty("location") as string;
        const element = document.createElement('span')
        const strongText = document.createElement('strong')
        strongText.textContent = location
        element.appendChild(strongText)
        this.infoWindow.setContent(element);
        this.infoWindow.setPosition(event.latLng);
        this.infoWindow.open(this.map);
      }
    );
  } 
}
